import React from 'react';
interface ArchiveLogoProps {
  className?: string;
  variant?: 'dark' | 'light';
}
const ARCHIVE_LOGO_URL = 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wZmCOMOYUn4CfsoCHQM0/media/699617b9905d472601bbd7ed.svg';
export function ArchiveLogo({
  className = '',
  variant = 'dark'
}: ArchiveLogoProps) {
  const isFooter = variant === 'light';
  return <div className={`relative flex shrink-0 items-center ${isFooter ? 'h-[76px] w-[min(340px,calc(100vw-40px))]' : 'h-[62px] w-[min(272px,calc(100vw-96px))] sm:h-[66px] sm:w-[316px]'} ${className}`} data-id="element-227" data-mp="3ayu8aj9imxet">
      <img src={ARCHIVE_LOGO_URL} alt="JAG Medical Solutions" className="block h-full w-full object-contain object-left" data-id="element-228" data-mp="3kv77txrqs5hh" />
    </div>;
}